import { useEffect, useMemo, useRef, useState } from 'react';
import Layout from '../../components/Layout'
import axios from "axios"
import { getCookie, setCookie } from '../../helpers/helpers'
import { defaultOptions, formatIsoString } from './helpers'
import { Link } from 'react-router-dom'
import { FaLink, FaUnlink, FaExclamationTriangle } from "react-icons/fa";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';
import { FaDisplay } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import { MdOutlineReportGmailerrorred } from "react-icons/md";
import { PiPath } from "react-icons/pi";
import TipsAndTricks from './TipsAndTricks';

const sites = ['nike', 'tipsport', 'fortuna', 'doxxbet', 'tipos', 'synottip']
const sports = ['football', 'tennis', 'hockey', 'basketball', 'handball', 'volleyball']

const getSportIcon = (sport) => {
    const icons = {
        football: '⚽',
        hockey: '🏒',
        basketball: '🏀',
        tennis: '🎾',
        handball: '🤾‍♂️',
        volleyball: '🏐',
    };
    return icons[sport] || '🏅';
}

const roundDigits = (num) => {
    if (isNaN(num) || num === null || num === undefined || num === '') return ''
    return Math.round((num + Number.EPSILON) * 100) / 100
}

const Filter = ({ options, setOptions, fetchNewArbitrages }) => {

    useEffect(() => {
        setCookie("live_options", (JSON.stringify(options)))
        fetchNewArbitrages()
    }, [options])

    return (
        <>
            <div className='text-white font1 fs-4 fw-bold text-center p-3  border-secondary'>Filtrovať ponuku</div>
            <div className="px-3">
                <div className="mb-3 text-white font1">Stávkové kancelárie</div>
                <div className="d-flex flex-wrap mb-3">
                    {sites.map(site => {
                        const active = options.sites.includes(site)
                        return (
                            <div
                                key={site}
                                onClick={() =>
                                    setOptions(prev => ({
                                        ...prev,
                                        sites: prev.sites.includes(site)
                                            ? prev.sites.filter(s => s !== site)
                                            : [...prev.sites, site],
                                    }))
                                }
                                className={`me-2 mb-2 d-flex align-items-center justify-content-center rounded-5 ${active ? "" : "opacity-50"
                                    }`}
                                style={{
                                    cursor: "pointer",
                                    background: active ? "#2b2b2b" : "transparent",
                                }}
                                title={site}
                            >
                                <img
                                    src={require(`../../static/images/sites/${site}.png`)}
                                    alt={site}
                                    style={{
                                        height: "22px",
                                        width: "auto",
                                        maxWidth: "100%",
                                        display: "block",
                                        margin: "0 auto",
                                        alignSelf: "center",
                                    }}
                                    className='rounded-5'
                                />
                            </div>
                        )
                    })}
                </div>

                <div className="mb-2 text-white font1">Športy</div>
                <div className="d-flex flex-wrap mb-3">
                    {sports.map(sp => {
                        const active = options.sports.includes(sp)
                        return (
                            <div
                                key={sp}
                                onClick={() =>
                                    setOptions(prev => ({
                                        ...prev,
                                        sports: prev.sports.includes(sp)
                                            ? prev.sports.filter(s => s !== sp)
                                            : [...prev.sports, sp],
                                    }))
                                }
                                className={`me-2 mb-2 d-flex align-items-center justify-content-center font1 rounded-pill px-3 py-1 ${active ? "bg-light text-dark" : "text-white bg-transparent border border-secondary"
                                    }`}
                                style={{ cursor: "pointer", fontSize: "0.9rem" }}
                            >
                                {sp}
                            </div>
                        )
                    })}
                </div>
                <div className="mb-2 text-white font1">Zoradiť podľa</div>
                <div className="d-flex flex-wrap mb-3">
                    {[
                        { key: 'length', name: 'Času platnosti' },
                        { key: 'roi', name: 'ROI' }
                    ].map(item => {
                        const active = options.sortBy === item.key
                        return (
                            <div
                                key={item.key}
                                onClick={() => setOptions(prev => ({ ...prev, sortBy: item.key }))}
                                className={`me-2 mb-2 d-flex align-items-center justify-content-center font1 rounded-pill px-3 py-1 ${active ? "bg-light text-dark" : "text-white bg-transparent border border-secondary"
                                    }`}
                                style={{ cursor: "pointer", fontSize: "0.9rem" }}
                            >{item.name}</div>
                        )
                    })}
                </div>

                <div className="mb-3">
                    <div className="text-white font1 mb-1">Minimálne ROI (%)</div>
                    <input
                        type="number"
                        defaultValue={options.min_roi}
                        onChange={e => setOptions(prev => ({ ...prev, min_roi: Number(e.target.value) }))}
                        className="form-control text-center"
                        style={{ background: "#222222", color: "#fff", height: "36px" }}
                        step="0.1"
                    />
                </div>

                <div className="mb-3">
                    <div className="text-white font1 mb-1">Minimálne aktivna (sekundy)</div>
                    <input
                        type="number"
                        defaultValue={options.min_active}
                        onChange={e => setOptions(prev => ({ ...prev, min_active: Number(e.target.value) }))}
                        className="form-control text-center"
                        style={{ background: "#222222", color: "#fff", height: "36px" }}
                    />
                </div>

                <div className="d-flex gap-2">
                    <button
                        onClick={() => {
                            fetchNewArbitrages()
                        }}
                        className="btn btn-sm btn-primary flex-fill"
                        style={{ background: "#1e88e5", border: "none" }}
                    >
                        Použiť filtre
                    </button>

                    <button
                        onClick={() => {
                            setOptions(defaultOptions)
                        }}
                        className="btn btn-sm btn-outline-light flex-fill"
                    >
                        Obnoviť
                    </button>
                </div>

                <div className="mt-3 text-white-50" style={{ fontSize: "0.85rem" }}>
                    Aktívne kancelárie: {options.sites.length} • Športy: {options.sports.length}
                </div>
            </div>
        </>
    )
}

const Search = ({ games, setLeftBar, setWatchSportradarid }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredGames, setFilteredGames] = useState([]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredGames([]);
        } else {
            const lowercasedFilter = searchTerm.toLowerCase();
            const uniqueGames = games.reduce((acc, current) => {
                if (!acc.find(item => item.sportradarid === current.sportradarid)) {
                    acc.push(current);
                }
                return acc;
            }, []);

            const filtered = uniqueGames.filter(game =>
                game.home.toLowerCase().includes(lowercasedFilter) ||
                game.away.toLowerCase().includes(lowercasedFilter)
            );
            setFilteredGames(filtered);
        }
    }, [searchTerm, games]);

    return (
        <>
            <div className='text-white font1 fs-4 fw-bold text-center p-3 border-secondary'>Vyhľadať Zápas</div>
            <div className='px-3'>
                <input
                    type="text"
                    className="form-control text-center placeholder-color-white"
                    placeholder="Zadajte názov tímu"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    style={{ background: "#161616", color: "#fff", height: "40px", border: '1px solid #333' }}
                />
            </div>
            <div className='px-3 mt-3 overflow-auto' style={{ maxHeight: 'calc(100vh - 250px)' }}>
                {searchTerm.trim() !== '' && filteredGames.map((game, index) => (
                    <div key={index} className='text-white mb-2 rounded-3 p-2' style={{ background: '#161616' }}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='font1 text-truncate fw-bold' style={{ fontSize: '0.9rem' }}>{game.home} vs {game.away}</div>
                            <div className='font1 text-secondary' style={{ fontSize: '1.2rem' }}>{getSportIcon(game.sport)}</div>
                        </div>
                        <div className='d-flex justify-content-between align-items-center mt-2'>
                            <div className='font1 text-secondary'>Počet arbitráží: <span className='fw-bold text-white'>{game.count}</span></div>
                            <button onClick={() => { setWatchSportradarid(game.sportradarid); setLeftBar('watch'); }} className='btn btn-sm btn-primary' style={{ background: "#1e88e5", border: "none", fontSize: '0.8rem' }}>Sledovať</button>
                        </div>
                    </div>
                ))}
                {searchTerm.trim() !== '' && filteredGames.length === 0 && <div className='text-white-50 text-center mt-4'>Nenašli sa žiadne zápasy.</div>}
            </div>
        </>
    );
}

const Top = ({ topOptions, setTopOptions, fetchTop, top, setLeftBar, setWatchSportradarid, fetchNewArbitrages }) => {
    const [changeTopFilter, setChangeTopFilter] = useState(false)

    return (
        <>
            <div className='text-white font1 fs-4 fw-bold text-center p-3 border-secondary'>Top Zápasy</div>
            <div className='text-white font1 px-3 text-center' style={{ 'fontSize': '0.75rem' }}>
                Zápasy s najväčším počtom arbitráží nad {topOptions.min_roi}% ktoré boli aktívne aspoň {topOptions.min_active} sekúnd za posledných {topOptions.max_age} minút.
            </div>
            <div className='container px-3'>
                <div
                    onClick={() => (setChangeTopFilter(!changeTopFilter))}
                    className=' mt-2 rounded rounded-3 text-center px-3 py-2 fw-bold font1 text-secondary'
                    style={{ 'backgroundColor': '#161616', 'cursor': 'pointer' }}
                >Upraviť filter</div>
            </div>

            {changeTopFilter &&
                <div className='px-3 mt-2'>
                    <div className="mb-2">
                        <div className="text-white font1 mb-1">Minimálne ROI (%)</div>
                        <input
                            type="number"
                            defaultValue={topOptions.min_roi}
                            onChange={e => setTopOptions(prev => ({ ...prev, min_roi: Number(e.target.value) }))}
                            className="form-control text-center"
                            style={{ background: "#161616", color: "#fff", height: "36px" }}
                        />
                    </div>
                    <div className="mb-2">
                        <div className="text-white font1 mb-1">Minimálne aktívna (sekundy)</div>
                        <input
                            type="number"
                            defaultValue={topOptions.min_active}
                            onChange={e => setTopOptions(prev => ({ ...prev, min_active: Number(e.target.value) }))}
                            className="form-control text-center"
                            style={{ background: "#161616", color: "#fff", height: "36px" }}
                        />
                    </div>
                    <div className="mb-2">
                        <div className="text-white font1 mb-1">Maximálne staré (minúty)</div>
                        <input
                            type="number"
                            defaultValue={topOptions.max_age}
                            onChange={e => setTopOptions(prev => ({ ...prev, max_age: Number(e.target.value) }))}
                            className="form-control text-center"
                            style={{ background: "#161616", color: "#fff", height: "36px" }}
                        />
                    </div>
                    <button
                        onClick={() => {
                            fetchTop()
                            setChangeTopFilter(false)
                        }}
                        className="btn btn-sm btn-primary w-100 mt-2"
                        style={{ background: "#1e88e5", border: "none" }}
                    >
                        Použiť filtre
                    </button>
                </div>
            }

            <div className='px-3 mt-3 overflow-auto' style={{ maxHeight: 'calc(100vh - 350px)' }}>
                {top.map((game, index) => (
                    <div key={index} className='text-white mb-2 rounded-3 p-2' style={{ background: '#161616' }}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='font1 text-truncate fw-bold' style={{ fontSize: '0.9rem' }}>{game.home} vs {game.away}</div>
                            <div className='font1 text-secondary' style={{ fontSize: '1.2rem' }}>{getSportIcon(game.sport)}</div>
                        </div>
                        <div className='d-flex justify-content-between align-items-center mt-2'>
                            <div className='d-flex gap-2 align-items-center'>
                                <img src={require(`../../static/images/sites/${game.offer1_site}.png`)} style={{ height: '20px' }} className="rounded-1" alt={game.offer1_site} />
                                <img src={require(`../../static/images/sites/${game.offer2_site}.png`)} style={{ height: '20px' }} className="rounded-1" alt={game.offer2_site} />
                            </div>
                            <div className='font1 badge bg-secondary'>Počet: {game.count}</div>
                            <button onClick={() => { setWatchSportradarid(game.sportradarid); setLeftBar('watch'); }} className='btn btn-sm btn-primary' style={{ background: "#1e88e5", border: "none", fontSize: '0.8rem' }}>Sledovať</button>
                        </div>
                    </div>
                ))}
                {top.length === 0 && <div className='text-white-50 text-center mt-4'>Nenašli sa žiadne top zápasy.</div>}
            </div>
        </>
    )
}

const Watch = ({ watchData, setLeftBar, fetchSportradaridData, watchFilters, setWatchFilters }) => {
    const { sites: watchDataSites, arbitrages: watchDataArbitrages, sportradarid: watchSportradarid } = watchData;
    const [view, setView] = useState('zapas'); // 'zapas', 'linky', 'arbitraze'
    const [showFilters, setShowFilters] = useState(false);


    if (!watchSportradarid) {
        return <div className='text-white-50 text-center p-3'>Vyberte zápas na sledovanie.</div>;
    }

    return (
        <>
            {/* <div className='text-white p-3 text-center font-weight-bold text-uppercase font1' style={{ 'fontSize': '1.5rem' }}>
                Sledovanie Zapasu
            </div> */}
            {watchSportradarid && (
                <div className='px-3 py-2' >
                    {/* <div className='text-white text-center lh-1 mt-2 font1 fs-2' >{watchDataSites?.[0]?.home}</div>
                    <div className='text-secondary text-center lh-1 font1' style={{ 'fontSize': '0.9rem' }}>vs</div>
                    <div className='text-white text-center lh-1 font1 fs-2'>{watchDataSites?.[0]?.away}</div> */}

                    <div className='text-white text-center font1 fs-2'>{watchDataSites?.[0]?.home} <span className='fs-6 text-secondary'>vs.</span> {watchDataSites?.[0]?.away}</div>

                    <div className="d-flex justify-content-center gap-2 mt-3">
                        <button onClick={() => setView('zapas')} className={`btn btn-sm ${view === 'zapas' ? 'btn-light' : 'btn-outline-secondary'}`}>Zápas</button>
                        <button onClick={() => setView('linky')} className={`btn btn-sm ${view === 'linky' ? 'btn-light' : 'btn-outline-secondary'}`}>Linky</button>
                        <button onClick={() => setView('arbitraze')} className={`btn btn-sm ${view === 'arbitraze' ? 'btn-light' : 'btn-outline-secondary'}`}>Arbitráže</button>
                    </div>

                    {view === 'zapas' && watchSportradarid[0] !== 'F' && (
                        <div className='overflow-auto rounded-4 mt-2' style={{ maxHeight: 'calc(100vh - 285px)' }}>

                            <iframe
                                width="100%"
                                height="600px"
                                src={`https://static.doxxbet.sk/mobile/matchtracker/mt.v1.4.html?language=sk&matchId=${watchSportradarid}&platform=web`}
                                frameBorder="0"
                                allowFullScreen
                                style={{ display: 'block', marginTop: '0rem' }}
                                className='rounded rounded-4'
                            />
                        </div>
                    )}

                    {view === 'linky' && (
                        <div className='d-flex flex-wrap text-center justify-content-center align-items-center mt-3'>
                            {watchDataSites?.map((game, index) => (
                                <Link key={index} to={game.url} target="_blank" className="col-auto mx-1 my-1 d-flex justify-content-center align-items-center">
                                    <img
                                        src={require(`../../static/images/sites/${game.site}.png`)}
                                        style={{ maxWidth: '60px', height: '100%', marginTop: '0px' }}
                                        className="rounded-1"
                                        alt={game.site}
                                    />
                                </Link>
                            ))}
                        </div>
                    )}

                    {view === 'arbitraze' && (
                        <div className='mt-3'>
                            <div onClick={() => setShowFilters(!showFilters)} className='text-secondary text-center fw-bold font1' style={{ cursor: 'pointer' }}>
                                Filtrovať arbitráže
                            </div>
                            {showFilters && (
                                <div className='p-2 rounded-3 mt-2' style={{ background: '#161616' }}>
                                    <div className="mb-2">
                                        <div className="text-white-50 font1 mb-1" style={{ fontSize: '0.8rem' }}>Min ROI (%)</div>
                                        <input
                                            type="number"
                                            defaultValue={watchFilters.min_roi}
                                            onChange={e => setWatchFilters(prev => ({ ...prev, min_roi: Number(e.target.value) }))}
                                            className="form-control form-control-sm text-center"
                                            style={{ background: "#222222", color: "#fff", border: '1px solid #333' }}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <div className="text-white-50 font1 mb-1" style={{ fontSize: '0.8rem' }}>Min aktívna (sekundy)</div>
                                        <input
                                            type="number"
                                            defaultValue={watchFilters.min_active}
                                            onChange={e => setWatchFilters(prev => ({ ...prev, min_active: Number(e.target.value) }))}
                                            className="form-control form-control-sm text-center"
                                            style={{ background: "#222222", color: "#fff", border: '1px solid #333' }}
                                        />
                                    </div>
                                    <button
                                        onClick={() => {
                                            fetchSportradaridData()
                                        }}
                                        className="btn btn-sm btn-primary w-100 mt-2"
                                        style={{ background: "#1e88e5", border: "none" }}
                                    >
                                        Použiť filtre
                                    </button>
                                </div>
                            )}
                            <div className='px-2 overflow-auto mt-3' style={{ maxHeight: 'calc(100vh - 350px)' }}>
                                {watchDataArbitrages?.length === 0 && (
                                    <div className='text-white-50 text-center mt-4'>Pre tento zápas sa nenašli žiadne arbitráže so zadanými filtrami.</div>
                                )}
                                {watchDataArbitrages?.map((arbitrage, index) => (
                                    <div key={index} className='d-flex gap-2 text-white mb-2 rounded-3 p-2' style={{ background: '#161616' }}>
                                        <div className='d-flex flex-column align-items-center justify-content-center bg-dark rounded-2 p-1' style={{ width: '55px' }}>
                                            <div className='fw-bold' style={{ fontSize: '0.8rem', color: '#1e88e5' }}>{arbitrage.roi.toFixed(2)}%</div>
                                            <div className='text-white-50' style={{ fontSize: '0.6rem' }}>ROI</div>
                                        </div>
                                        <div className='d-flex flex-column flex-grow-1'>
                                            <div className='d-flex align-items-center gap-2'>
                                                <div className='d-flex flex-column gap-1'>
                                                    <img src={require(`../../static/images/sites/${arbitrage.offer1_site}.png`)} style={{ height: '20px' }} alt={arbitrage.offer1_site} />
                                                    <img src={require(`../../static/images/sites/${arbitrage.offer2_site}.png`)} style={{ height: '20px' }} alt={arbitrage.offer2_site} />
                                                </div>
                                                <div className='d-flex flex-column gap-1'>

                                                    {/* <div className='font1 fw-bold text-light text-truncate' style={{ fontSize: '0.95rem' }}> */}
                                                    <span>{arbitrage.market} {arbitrage.market_quantity}</span>
                                                    <span className='text-white-50 font1' style={{ fontSize: '0.8rem' }}>
                                                        Vznikla pred {arbitrage.old > 200 ? `${(arbitrage.old / 60).toFixed(0)} min` : `${arbitrage.old.toFixed(0)} s`} • Trvala {arbitrage.length > 200 ? `${(arbitrage.length / 60).toFixed(0)} min` : `${arbitrage.length.toFixed(0)} s`}

                                                    </span>
                                                </div>
                                            </div>
                                            {/* <div className='font1 text-white-50 mt-1' style={{ fontSize: '0.75rem' }}>
                                                Vznikla pred {arbitrage.old > 200 ? `${(arbitrage.old / 60).toFixed(0)} min` : `${arbitrage.old.toFixed(0)} s`} • Trvala {arbitrage.length > 200 ? `${(arbitrage.length / 60).toFixed(0)} min` : `${arbitrage.length.toFixed(0)} s`}
                                            </div> */}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}

const Stats = ({ statsGames, statsArbitrages }) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );

    const [activeChart, setActiveChart] = useState('games');

    const gamesChartData = useMemo(() => {
        if (!statsGames || statsGames.length === 0) {
            return null;
        }

        const uniqueSites = [...new Set(statsGames.map(g => g.site))];
        const labels = [...new Set(statsGames.map(g => g.start_rounded))].sort((a, b) => a - b).map(hour => `${hour}:00`);

        const siteColors = {
            nike: 'rgba(255, 128, 0, 0.6)',
            tipsport: 'rgba(17, 134, 240, 0.6)',
            fortuna: 'rgba(255, 219, 1, 0.6)',
            doxxbet: 'rgba(204, 0, 0, 0.6)',
        };

        const datasets = uniqueSites.map(site => {
            return {
                label: site,
                data: labels.map(label => {
                    const hour = parseInt(label.split(':')[0], 10);
                    const game = statsGames.find(g => g.start_rounded === hour && g.site === site);
                    return game ? parseInt(game.game_count, 10) : 0;
                }),
                backgroundColor: siteColors[site] || 'rgba(128, 128, 128, 0.6)',
                borderColor: siteColors[site]?.replace('0.6', '1') || 'rgba(128, 128, 128, 1)',
                borderWidth: 1,
            };
        });

        return { labels, datasets };
    }, [statsGames]);

    const arbitragesChartData = useMemo(() => {
        if (!statsArbitrages || statsArbitrages.length === 0) {
            return null;
        }

        const uniqueSites = [...new Set(statsArbitrages.map(a => a.site))];
        const labels = [...new Set(statsArbitrages.map(a => a.hour_of_day))].sort((a, b) => a - b).map(hour => `${hour}:00`);

        const siteColors = {
            nike: 'rgba(255, 128, 0, 0.6)',
            tipsport: 'rgba(17, 134, 240, 0.6)',
            fortuna: 'rgba(255, 219, 1, 0.6)',
            doxxbet: 'rgba(204, 0, 0, 0.6)',
        };

        const datasets = uniqueSites.map(site => {
            return {
                label: site,
                data: labels.map(label => {
                    const hour = parseInt(label.split(':')[0], 10);
                    const arbitrage = statsArbitrages.find(a => a.hour_of_day === hour && a.site === site);
                    return arbitrage ? parseInt(arbitrage.arbitrage_count, 10) : 0;
                }),
                backgroundColor: siteColors[site] || 'rgba(128, 128, 128, 0.6)',
                borderColor: siteColors[site]?.replace('0.6', '1') || 'rgba(128, 128, 128, 1)',
                borderWidth: 1,
            };
        });

        return { labels, datasets };
    }, [statsArbitrages]);

    const chartData = useMemo(() => {
        if (activeChart === 'games') {
            return gamesChartData;
        }
        return arbitragesChartData;
    }, [activeChart, gamesChartData, arbitragesChartData]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    color: 'white',
                },
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                ticks: {
                    color: 'white',
                },
                grid: {
                    color: 'rgba(255, 255, 255, 0.1)',
                }
            },
            y: {
                ticks: {
                    color: 'white',
                },
                grid: {
                    color: 'rgba(255, 255, 255, 0.1)',
                }
            },
        },
    };

    return (
        <>
            <div className='text-white font1 fs-4 fw-bold text-center p-3 border-secondary'>
                {activeChart === 'games' ? 'Štatistiky počtu zápasov' : 'Štatistiky počtu arbitráží'}
            </div>
            <div className="d-flex justify-content-center gap-2 mb-3 px-3">
                <button
                    onClick={() => setActiveChart('games')}
                    className={`btn btn-sm ${activeChart === 'games' ? 'btn-light' : 'btn-outline-secondary'}`}
                >Zápasy</button>
                <button
                    onClick={() => setActiveChart('arbitrages')}
                    className={`btn btn-sm ${activeChart === 'arbitrages' ? 'btn-light' : 'btn-outline-secondary'}`}
                >Arbitráže</button>
            </div>
            <div className='text-white-50 font1 px-3 text-center mb-2' style={{ 'fontSize': '0.8rem' }}>
                {activeChart === 'games'
                    ? "Graf zobrazuje priemerný počet začiatkov live zápasov v jednotlivých hodinách za posledných 7 dní. Tieto dáta vám môžu pomôcť identifikovať, kedy je najväčšia ponuka zápasov a teda aj najvyššia pravdepodobnosť výskytu arbitrážnych príležitostí."
                    : "Graf zobrazuje priemerný počet arbitráží (ROI 1-20%, aktívne > 25s) v jednotlivých hodinách za posledné 3 dni. Pomôže vám to zistiť, kedy je najviac arbitrážnych príležitostí."}
            </div>
            <div className='px-3 overflow-auto' style={{ maxHeight: 'calc(100vh - 200px)' }}>
                {chartData ? (
                    <Bar options={options} data={chartData} />
                ) : (
                    <div className='text-white-50 text-center mt-4'>Načítavajú sa štatistiky...</div>
                )}
            </div>
        </>
    );
}

const Alert = ({ alertSettings: settings, setAlertSettings: setSettings }) => {


    useEffect(() => {
        setCookie('live_alert_settings', JSON.stringify(settings));
    }, [settings]);

    const handleSettingChange = (key, value) => {
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    const playSound = () => {
        const audio = new Audio(`/audio/${settings.sound}`);
        audio.volume = settings.volume;
        audio.play().catch(e => console.error("Chyba pri prehrávaní zvuku:", e));
    };

    return (
        <>
            <div className='text-white font1 fs-4 fw-bold text-center p-3 border-secondary'>Nastavenia Upozornení</div>
            <div className='px-3'>
                <div className="form-check form-switch mb-4 p-0 d-flex align-items-center gap-2">
                    <label className="form-check-label text-white" htmlFor="enableLightNotifications">
                        Svetelné upozornenia
                    </label>
                    <input
                        className="form-check-input ms-auto"
                        type="checkbox"
                        role="switch"
                        id="enableLightNotifications"
                        checked={settings.lightEnabled}
                        onChange={e => handleSettingChange('lightEnabled', e.target.checked)}
                        style={{ transform: 'scale(1.3)', cursor: 'pointer' }}
                    />
                </div>
                <div className={`mb-3 ${!settings.lightEnabled && 'opacity-50'}`}>
                    <label htmlFor="minRoi" className="form-label text-white-50 font1 mb-1">Minimálne aktívna (sekundy) pre svetelné upozornenie</label>
                    <input
                        type="number"
                        id="minRoi"
                        defaultValue={settings.lightMinActive}
                        onChange={e => handleSettingChange('lightMinActive', Number(e.target.value))}
                        className="form-control text-center"
                        style={{ background: "#161616", color: "#fff", height: "36px", border: '1px solid #333' }}
                        disabled={!settings.lightEnabled}
                    />
                </div>

                <div className="form-check form-switch mb-4 p-0 d-flex align-items-center gap-2">
                    <label className="form-check-label text-white" htmlFor="enableNotifications">
                        Zvukové upozornenia
                    </label>
                    <input
                        className="form-check-input ms-auto"
                        type="checkbox"
                        role="switch"
                        id="enableNotifications"
                        defaultChecked={settings.enabled}
                        onChange={e => handleSettingChange('enabled', e.target.checked)}
                        style={{ transform: 'scale(1.3)', cursor: 'pointer' }}
                    />
                </div>



                <div className={`mb-3 ${!settings.enabled && 'opacity-50'}`}>
                    <label htmlFor="minRoi" className="form-label text-white-50 font1 mb-1">Minimálne ROI (%) pre upozornenie</label>
                    <input
                        type="number"
                        id="minRoi"
                        defaultValue={settings.minRoi}
                        onChange={e => handleSettingChange('minRoi', Number(e.target.value))}
                        className="form-control text-center"
                        style={{ background: "#161616", color: "#fff", height: "36px", border: '1px solid #333' }}
                        disabled={!settings.enabled}
                    />
                </div>

                <div className={`mb-3 ${!settings.enabled && 'opacity-50'}`}>
                    <label htmlFor="minActiveAlert" className="form-label text-white-50 font1 mb-1">Minimálne aktívna (sekundy)</label>
                    <input
                        type="number"
                        id="minActiveAlert"
                        defaultValue={settings.minActive}
                        onChange={e => handleSettingChange('minActive', Number(e.target.value))}
                        className="form-control text-center"
                        style={{ background: "#161616", color: "#fff", height: "36px", border: '1px solid #333' }}
                        disabled={!settings.enabled}
                    />
                </div>

                <div className={`mb-4 ${!settings.enabled && 'opacity-50'}`}>
                    <label htmlFor="volume" className="form-label text-white-50 font1 mb-1">Hlasitosť ({Math.round(settings.volume * 100)}%)</label>
                    <input
                        type="range"
                        id="volume"
                        min="0"
                        max="1"
                        step="0.01"
                        defaultValue={settings.volume}
                        onChange={e => handleSettingChange('volume', parseFloat(e.target.value))}
                        className="form-range"
                        disabled={!settings.enabled} />
                </div>
                <div className="d-flex gap-2 mt-4">
                    <button onClick={playSound} className="btn btn-sm btn-outline-light flex-fill" disabled={!settings.enabled}>Otestovať Zvuk</button>
                </div>
            </div>
        </>
    );
}

const ArbitragesList = ({ token, arbitrages, setLeftBar, setWatchSportradarid, alertSettings }) => {
    const [stakes, setStakes] = useState({});
    const [lastStakeInfo, setLastStakeInfo] = useState({});
    const [linked, setLinked] = useState({});

    const handleReportError = (arbitrage) => {
        if (window.confirm('Si si istý, že zápas je zle spárovaný?')) {
            axios.post(`${process.env.REACT_APP_API}/invalid/live/games`, {
                token,
                ids: [arbitrage.offer1_gameid, arbitrage.offer2_gameid]
            }).then(response => {
                alert('Chyba nahlásená úspešne.');
            }).catch(error => {
                alert('Vyskytla sa chyba pri nahlasovaní.');
                console.error(error);
            });
        }
    };
    const handleStakeChange = (groupKey, stakeName, value) => {
        setStakes(prev => ({
            ...prev,
            [groupKey]: {
                ...prev[groupKey],
                [stakeName]: value
            }
        }));
        setLastStakeInfo({ groupKey, stakeName });
    };

    useEffect(() => {
        if (!lastStakeInfo.groupKey) return;

        const { groupKey, stakeName } = lastStakeInfo;
        const arbitrage = arbitrages.find(e => e.group_key === groupKey);
        if (!arbitrage || linked[groupKey] === false) return;

        const currentStakes = stakes[groupKey] || {};
        const stake1 = currentStakes.stake1 || '';
        const stake2 = currentStakes.stake2 || '';
        const { offer1_value: value1, offer2_value: value2 } = arbitrage;

        if (stakeName === 'stake1') {
            const newStake2 = stake1 ? roundDigits((parseFloat(stake1) * value1 / value2)) : '';
            setStakes(prev => ({ ...prev, [groupKey]: { ...prev[groupKey], stake2: newStake2 } }));
        } else if (stakeName === 'stake2') {
            const newStake1 = stake2 ? roundDigits((parseFloat(stake2) * value2 / value1)) : '';
            setStakes(prev => ({ ...prev, [groupKey]: { ...prev[groupKey], stake1: newStake1 } }));
        }
    }, [stakes, lastStakeInfo, arbitrages, linked]);

    const toggleLink = (groupKey) => {
        setLinked(prev => ({ ...prev, [groupKey]: !prev[groupKey] && prev[groupKey] !== false }));
    };

    return (
        <>
            {arbitrages.map((arbitrage) => {
                const { id, group_key, offer1_sport, roi, offer1_home, offer2_away, offer1_site, offer2_site, offer1_url, offer2_url, offer1_bet, offer2_bet, offer1_value, offer2_value, offer1_color_primary, offer2_color_primary, offer1_sportradarid, createdAt, updatedAt } = arbitrage;
                const length = ((new Date() - new Date(createdAt)) / 1000);
                const old = ((new Date() - new Date(updatedAt)) / 1000);
                const isLinked = linked[group_key] !== false;
                const currentStakes = stakes[group_key] || { stake1: '', stake2: '' };
                const stake1 = parseFloat(currentStakes.stake1) || 0;
                const stake2 = parseFloat(currentStakes.stake2) || 0;
                const guaranteedProfit = (stake1 * offer1_value) - (stake1 + stake2);

                const pathsDiffer = arbitrage.offer1_path1 !== arbitrage.offer2_path1;

                return (
                    <div key={id} className='text-white rounded-4 mb-3 p-3 ' style={{ background: '#222222', border: (alertSettings.lightEnabled && length > alertSettings.lightMinActive) ? '1px solid #ffc107' : 'none' }}>
                        <div className='row g-3 align-items-center'>
                            <div className='col-auto'>
                                <div className='fw-bold font1 text-center' style={{ fontSize: '1.8rem', color: '#1e88e5', width: '80px' }}>
                                    {roi.toFixed(2)}%
                                </div>
                            </div>
                            <div className='col-12 col-lg'>
                                <div className='d-flex align-items-center h-100'>
                                    <div className='fs-4 me-3' style={{ lineHeight: 1 }}>{getSportIcon(offer1_sport)}</div>
                                    <div className='flex-grow-1' style={{ minWidth: 0 }}>
                                        <div className='fw-bold text-light font1 fs-5 text-truncate'>{offer1_home} vs {offer2_away}</div>
                                        <div className='d-flex align-items-center gap-2 text-white-50 font1 text-uppercase' style={{ fontSize: '0.8rem' }}>
                                            <div className='text-truncate' >{arbitrage.market}</div>
                                            {/* {pathsDiffer && <div className='text-truncate' >| {arbitrage.offer2_path1}</div>} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-lg-6'>
                                <div className='row g-2'>
                                    {[1, 2].map(i => {
                                        const offer = {
                                            site: i === 1 ? offer1_site : offer2_site,
                                            url: i === 1 ? offer1_url : offer2_url,
                                            bet: i === 1 ? offer1_bet : offer2_bet,
                                            value: i === 1 ? offer1_value : offer2_value,
                                            color: i === 1 ? offer1_color_primary : offer2_color_primary,
                                            stakeName: i === 1 ? 'stake1' : 'stake2',
                                            paths: [arbitrage[`offer${i}_path1`], arbitrage[`offer${i}_path2`], arbitrage[`offer${i}_path3`]].filter(Boolean)
                                        };
                                        return (
                                            <div key={i} className='col-12'>
                                                <div className='d-flex align-items-center gap-2 align-items-center justify-content-center'>

                                                    <div className='text-end flex-grow-1 text-uppercase text-secondary font1 text-truncate' title={offer.paths.join(' | ')}>{offer.bet}</div>
                                                    <div className='fw-bold font1 fs-5 text-end' style={{ color: offer.color, 'width': '40px' }}>{offer.value}</div>

                                                    <Link to={offer.url} target="_blank">
                                                        <img src={require(`../../static/images/sites/${offer.site}.png`)} style={{ height: '28px' }} className="rounded-2" alt={offer.site} />
                                                    </Link>
                                                    <div className="input-group" style={{ width: '100px' }}>
                                                        <input
                                                            defaultValue={currentStakes[offer.stakeName]}
                                                            onChange={e => handleStakeChange(group_key, offer.stakeName, e.target.value)}
                                                            type="number"
                                                            className="form-control text-end text-white pe-1 py-0"
                                                            placeholder="0.00"
                                                            style={{ background: '#161616', border: '0px solid #333', borderRight: 'none', 'height': '30px' }}
                                                        />
                                                        <span className="input-group-text py-0" style={{ background: '#161616', border: '0px solid #333', borderLeft: 'none', color: '#6c757d' }}>€</span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        <div className='d-flex align-items-center justify-content-between mt-3 pt-3 border-top border-secondary border-opacity-25'>
                            <div className='d-flex align-items-center gap-3'>
                                {/* <div onClick={() => toggleLink(group_key)} style={{ cursor: 'pointer' }} title={isLinked ? "Odpojiť kalkulačku" : "Prepojiť kalkulačku"}>
                                    {isLinked ? <FaLink size="1.2em" /> : <FaUnlink size="1.2em" className="text-secondary" />}
                                </div> */}
                                <div onClick={() => { setLeftBar('watch'); setWatchSportradarid(offer1_sportradarid); }} style={{ cursor: 'pointer' }} title="Sledovať zápas">
                                    <FaEye size="1.3em" />
                                </div>
                                <div onClick={() => handleReportError(arbitrage)} style={{ cursor: 'pointer' }} title="Nahlásiť chybu">
                                    <MdOutlineReportGmailerrorred size="1.4em" />
                                </div>
                                <div>
                                    <PiPath size="1.4em" onClick={() => navigator.clipboard.writeText(arbitrage.offer1_path1)}
                                        title={`skopírovať ${arbitrage.offer1_path1}`} style={{ cursor: 'pointer', 'color': offer1_color_primary }} />
                                </div>
                                <div>
                                    <PiPath size="1.4em" onClick={() => navigator.clipboard.writeText(arbitrage.offer2_path1)}
                                        title={`skopírovať ${arbitrage.offer2_path1}`} style={{ cursor: 'pointer', 'color': offer2_color_primary }} />
                                </div>
                            </div>
                            <div className='d-flex align-items-center gap-3 text-white-50 font1' style={{ fontSize: '0.8rem' }}>
                                {stake1 > 0 && stake2 > 0 && (
                                    <div className='d-flex gap-3'>
                                        <div title="Celkový vklad">Vklad: <span className='fw-bold text-white'>{(stake1 + stake2).toFixed(2)}€</span></div>
                                        <div title="Garantovaný zisk">
                                            Zisk: <span className='fw-bold text-success'>{guaranteedProfit.toFixed(2)}€ ({((guaranteedProfit / (stake1 + stake2)) * 100).toFixed(2)}%)</span>
                                        </div>
                                    </div>
                                )}
                                <div>Naposledy skontrolovaná: <span className='fw-bold text-white'>{old < 120 ? `${old.toFixed(0)}s` : `${(old / 60).toFixed(0)}m`}</span></div>
                                <div className='d-flex align-items-center gap-1 text-secondary' >Aktivna: <span className='fw-bold' style={{ 'color': (alertSettings.lightEnabled && length > alertSettings.lightMinActive) ? 'orange' : 'white' }}>{length < 120 ? `${length.toFixed(0)}s` : `${(length / 60).toFixed(0)}m`}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
            {arbitrages.length === 0 && (
                <div className='d-flex justify-content-center align-items-center' style={{ height: 'calc(100vh - 200px)' }}>
                    <div className='text-center'>
                        <div className='fs-1'>😕</div>
                        <div className='text-white-50 mt-2'>Nenašli sa žiadne live arbitráže.</div>
                        <div className='text-white-50' style={{ fontSize: '0.8rem' }}>Skúste upraviť filtre alebo počkajte na nové príležitosti.</div>
                    </div>
                </div>
            )}
        </>
    );
}

const TopArbitragesList = ({ topArbitrages, setWatchSportradarid, setLeftBar }) => {
    if (!topArbitrages || topArbitrages.length === 0) {
        return null;
    }

    return (
        <div className='mt-0'>
            {/* <h4 className='text-white font1 fw-bold text-center mb-3'>Top Arbitráže</h4> */}
            <div className='row g-3'>
                {topArbitrages.map((arbitrage, index) => (
                    <div key={index} className='col-12'>
                        <div className='text-white rounded-4 p-3' style={{ background: '#222222' }}>
                            <div className='row g-3 align-items-center'>
                                <div className='col-auto'>
                                    <div className='fw-bold font1 text-center' style={{ fontSize: '1.8rem', color: '#1e88e5', width: '80px' }}>
                                        {arbitrage.roi.toFixed(2)}%
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='d-flex align-items-center h-100'>
                                        <div className='fs-4 me-3' style={{ lineHeight: 1 }}>{getSportIcon(arbitrage.offer1_sport)}</div>
                                        <div className='flex-grow-1' style={{ minWidth: 0 }}>
                                            <div className='fw-bold text-light font1 fs-5 text-truncate'>{arbitrage.offer1_home} vs {arbitrage.offer2_away}
                                                <span className='px-2'>|</span>
                                                <span className='text-truncate text-uppercase font1'>{arbitrage.market} {arbitrage.market_quantity}</span>

                                            </div>
                                            <div className='d-flex align-items-center flex-wrap gap-x-3 gap-y-1 text-white-50 font1' style={{ fontSize: '0.8rem' }}>
                                                <div className='ps-0'>Vznikla pred: <span className='fw-bold text-white'>{arbitrage.old < 120 ? `${arbitrage.old.toFixed(0)}s` : `${(arbitrage.old / 60).toFixed(0)}m`}</span></div>
                                                <div className='ps-2'>Trvanie: <span className='fw-bold text-white'>{arbitrage.length < 120 ? `${arbitrage.length.toFixed(0)}s` : `${(arbitrage.length / 60).toFixed(0)}m`}</span></div>
                                                <div className='d-flex align-items-center justify-content-center gap-2 text-white ps-2' onClick={() => { setLeftBar('watch'); setWatchSportradarid(arbitrage.offer1_sportradarid); }} style={{ cursor: 'pointer' }} title="Sledovať zápas">
                                                    <FaEye size="1.3em" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-4 col-lg-4'>
                                    <div className='row g-2'>
                                        <div className='col-12'>
                                            <div className='d-flex align-items-center gap-2 align-items-center justify-content-center'>
                                                <div className='text-end flex-grow-1 text-uppercase text-secondary font1 text-truncate'>{arbitrage.offer1_bet}</div>
                                                <div className='fw-bold font1 fs-5 text-end' style={{ 'width': '40px' }}>{arbitrage.offer1_value}</div>
                                                <Link to={arbitrage.offer1_url} target="_blank">
                                                    <img src={require(`../../static/images/sites/${arbitrage.offer1_site}.png`)} style={{ height: '28px' }} className="rounded-2" alt={arbitrage.offer1_site} />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <div className='d-flex align-items-center gap-2 align-items-center justify-content-center'>
                                                <div className='text-end flex-grow-1 text-uppercase text-secondary font1 text-truncate'>{arbitrage.offer2_bet}</div>
                                                <div className='fw-bold font1 fs-5 text-end' style={{ 'width': '40px' }}>{arbitrage.offer2_value}</div>
                                                <Link to={arbitrage.offer2_url} target="_blank">
                                                    <img src={require(`../../static/images/sites/${arbitrage.offer2_site}.png`)} style={{ height: '28px' }} className="rounded-2" alt={arbitrage.offer2_site} />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

const LiveArbitrage = () => {
    const token = getCookie('token');
    const [leftBar, setLeftBar] = useState('filter') // filter, top, search, watch
    const [showTips, setShowTips] = useState(false);

    // const [options, setOptions] = useState(getCookie('live_options') ? JSON.parse(getCookie('live_options')) : defaultOptions)
    const [options, setOptions] = useState(() => (getCookie('live_options') ? { ...defaultOptions, ...JSON.parse(getCookie('live_options')) } : defaultOptions))
    const startedFetchNewArbitragesRef = useRef(false)
    const [arbitrages, setArbitrages] = useState([])
    const [oldAlertIds, setOldAlertIds] = useState([])
    const [top, setTop] = useState([])
    const [topArbitrages, setTopArbitrages] = useState([])
    const [games, setGames] = useState([])
    const [topOptions, setTopOptions] = useState({ min_roi: 3, min_active: 30, max_age: 25 })
    const [watchFilters, setWatchFilters] = useState({ min_roi: 1, min_active: 10 });
    const [watchSportradarid, setWatchSportradarid] = useState();
    const [watchDataSites, setWatchDataSites] = useState([])
    const [watchDataArbitrages, setWatchDataArbitrages] = useState([])
    const [statsGames, setStatsGames] = useState([])
    const [statsArbitrages, setStatsArbitrages] = useState([])
    const [alertSettings, setAlertSettings] = useState(() => {
        const saved = getCookie('live_alert_settings');
        try {
            return saved ? JSON.parse(saved) : { enabled: false, minRoi: 5, sound: 'alert1.mp3', volume: 0.5, minActive: 0, lightEnabled: true, lightMinActive: 20 };
        } catch (error) {
            return { enabled: false, minRoi: 5, sound: 'alert1.mp3', volume: 0.5, minActive: 0, lightEnabled: true, lightMinActive: 20 };
        }
    });

    useEffect(() => {
        setCookie('live_alert_settings', JSON.stringify(alertSettings));
    }, [alertSettings]);


    //alerts
    useEffect(() => {
        if (alertSettings.enabled) {
            const freshArbitrages = [...arbitrages].filter(a => !oldAlertIds.includes(a.id))
            console.log(oldAlertIds, freshArbitrages)

            const shouldAlert = freshArbitrages.some(a => {
                const arbitrageDuration = (new Date() - new Date(a.createdAt)) / 1000;
                return a.roi >= alertSettings.minRoi &&
                    arbitrageDuration >= alertSettings.minActive &&
                    options.sites.includes(a.offer1_site) &&
                    options.sites.includes(a.offer2_site);
            })

            if (shouldAlert) {
                const audio = new Audio(`/audio/${alertSettings.sound}`);
                audio.volume = alertSettings.volume;
                audio.play().catch(e => console.error("Chyba pri prehrávaní zvuku:", e));
            }

        }
        setOldAlertIds(arbitrages.filter(e => (alertSettings.enabled && e.roi >= alertSettings.minRoi && ((new Date() - new Date(e.createdAt)) / 1000) >= alertSettings.minActive)).map(e => e.id))

    }, [arbitrages])




    const fetchNewArbitrages = async () => {
        if (!startedFetchNewArbitragesRef.current) {
            startedFetchNewArbitragesRef.current = true;

            axios.post(`${process.env.REACT_APP_API}/abitrage/live`, { token, options: (options) })
                .then(response => {
                    setArbitrages(response.data.arbitrages);
                    startedFetchNewArbitragesRef.current = false
                })
                .catch(error => {
                    setArbitrages([])
                    startedFetchNewArbitragesRef.current = false
                })

        }
    }

    const fetchTopArbitrages = async () => {
        axios.post(`${process.env.REACT_APP_API}/abitrage/live/stats`, { token, options: { ...topOptions, top_arbitrages: true } })
            .then(response => {
                setTopArbitrages(response.data.arbitrages)
            })
            .catch(error => {
                setTopArbitrages([])
            })
    }


    const fetchTop = async () => {
        axios.post(`${process.env.REACT_APP_API}/abitrage/live/stats`, { token, options: topOptions })
            .then(response => {
                setTop(response.data.topGames)
                setGames(response.data.games)

            })
            .catch(error => {
                setTop([])
                setGames([])
            })
    }

    const fetchSportradaridData = async () => {
        axios.post(`${process.env.REACT_APP_API}/abitrage/live/stats`, { token, options: { sportradarid: watchSportradarid, ...watchFilters } })
            .then(response => {
                setWatchDataArbitrages(response.data.arbitrages)
                setWatchDataSites(response.data.games)
            })
            .catch(error => {
                setWatchDataArbitrages([])
                setWatchDataSites([])
            })
    }

    const fetchStats = async () => {
        axios.post(`${process.env.REACT_APP_API}/abitrage/live/stats`, { token, options: { games_stats: true } })
            .then(response => {
                setStatsGames(response.data.games)
                setStatsArbitrages(response.data.arbitrages)
            })
            .catch(error => {
                setStatsGames([])
                setStatsArbitrages([])
            })
    }

    // fetch new arbitrages every 3 seconds
    useEffect(() => {
        fetchNewArbitrages()
        const interval = setInterval(() => {
            fetchNewArbitrages()
        }, 2000)
        return () => clearInterval(interval)
    }, [])

    //fetch based od bar
    useEffect(() => {
        if (leftBar === 'top' || leftBar === 'search') {
            fetchTop()
        }
        if (leftBar === 'stats') {
            fetchStats()
        }
        if (leftBar === 'top_arbitrages') {
            fetchTopArbitrages()
        }
        if (leftBar === 'watch' && watchSportradarid) {
            fetchSportradaridData()
        }
    }, [leftBar, watchSportradarid])







    return (
        <Layout title="Live Arbitrage">
            {showTips && <TipsAndTricks setShowTips={setShowTips} />}
            {window.innerWidth <= 950
                ? <div className='text-white px-2 px-sm-4'>Pouzite prosim vacsiu obrazovku na zobrazenie live arbitrazi</div>
                :
                <div className='container-fluid'>
                    <div className='row p-3 pb-0'>
                        <div className='col-12 p-0'>
                            <div className='d-flex align-items-center rounded rounded-4 p-2 text-white font1' style={{ height: '75px', background: '#222222' }}>
                                <div style={{ 'width': '250px' }} className='d-flex justify-content-center align-items-center fs-4 fw-bold'>ARBITRAGE.SK</div>
                                <div className="d-flex align-items-center gap-2">
                                    <div
                                        onClick={() => (leftBar == 'filter' ? setLeftBar('') : setLeftBar('filter'))}
                                        className={`d-flex align-items-center justify-content-center rounded-3 px-3 py-2 fw-bold font1 ${leftBar === 'filter' ? 'bg-light text-dark' : 'text-secondary'
                                            }`}
                                        style={{ backgroundColor: leftBar !== 'filter' ? '#161616' : '', cursor: 'pointer' }}
                                    >
                                        Filtrovať
                                    </div>
                                    <div
                                        onClick={() => (leftBar == 'alert' ? setLeftBar('') : setLeftBar('alert'))}
                                        className={`d-flex align-items-center justify-content-center rounded-3 px-3 py-2 fw-bold font1 ${leftBar === 'alert' ? 'bg-light text-dark' : 'text-secondary'
                                            }`}
                                        style={{ backgroundColor: leftBar !== 'alert' ? '#161616' : '', cursor: 'pointer' }}
                                    >
                                        Upozorniť
                                    </div>
                                    <div
                                        onClick={() => (leftBar == 'top' ? setLeftBar('') : setLeftBar('top'))}
                                        className={`d-flex align-items-center justify-content-center rounded-3 px-3 py-2 fw-bold font1 ${leftBar === 'top' ? 'bg-light text-dark' : 'text-secondary'
                                            }`}
                                        style={{ backgroundColor: leftBar !== 'top' ? '#161616' : '', cursor: 'pointer' }}
                                    >
                                        Top zapasy
                                    </div>
                                    <div
                                        onClick={() => (leftBar == 'top_arbitrages' ? setLeftBar('') : setLeftBar('top_arbitrages'))}
                                        className={`d-flex align-items-center justify-content-center rounded-3 px-3 py-2 fw-bold font1 ${leftBar === 'top_arbitrages' ? 'bg-light text-dark' : 'text-secondary'
                                            }`}
                                        style={{ backgroundColor: leftBar !== 'top_arbitrages' ? '#161616' : '', cursor: 'pointer' }}
                                    >
                                        Top arbitraže
                                    </div>
                                    <div
                                        onClick={() => (leftBar == 'stats' ? setLeftBar('') : setLeftBar('stats'))}
                                        className={`d-flex align-items-center justify-content-center rounded-3 px-3 py-2 fw-bold font1 ${leftBar === 'stats' ? 'bg-light text-dark' : 'text-secondary'
                                            }`}
                                        style={{ backgroundColor: leftBar !== 'stats' ? '#161616' : '', cursor: 'pointer' }}
                                    >
                                        Štatistiky
                                    </div>
                                    <div
                                        onClick={() => (leftBar == 'search' ? setLeftBar('') : setLeftBar('search'))}
                                        className={`d-flex align-items-center justify-content-center rounded-3 px-3 py-2 fw-bold font1 ${leftBar === 'search' ? 'bg-light text-dark' : 'text-secondary'
                                            }`}
                                        style={{ backgroundColor: leftBar !== 'search' ? '#161616' : '', cursor: 'pointer' }}
                                    >
                                        Vyhladat zapas
                                    </div>
                                    <div
                                        onClick={() => setShowTips(true)}
                                        className={`d-flex align-items-center justify-content-center rounded-3 px-3 py-2 fw-bold font1 ${showTips ? 'bg-light text-dark' : 'text-secondary'
                                            }`}
                                        style={{ backgroundColor: !showTips ? '#161616' : '', cursor: 'pointer' }}
                                    >
                                        Tipy a triky
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        {/* left bar */}
                        <div className={`col-auto p-3 pe-0 ${!['filter', 'search', 'watch', 'top', 'stats', 'alert'].includes(leftBar) && 'd-none'}`} style={{ width: '400px', height: 'calc(100vh - 147px)', background: '#161616' }}>
                            <div className='d-flex flex-column rounded rounded-4' style={{ height: '100%', width: '100%', background: '#222222' }}>
                                {leftBar == 'filter' && <Filter options={options} setOptions={setOptions} fetchNewArbitrages={fetchNewArbitrages} />}
                                {leftBar == 'top' && <Top topOptions={topOptions} setTopOptions={setTopOptions} fetchTop={fetchTop} top={top} setLeftBar={setLeftBar} setWatchSportradarid={setWatchSportradarid} fetchNewArbitrages={fetchNewArbitrages} />}
                                {leftBar == 'search' && <Search games={games} setLeftBar={setLeftBar} setWatchSportradarid={setWatchSportradarid} />}
                                {leftBar == 'watch' && <Watch watchData={{ sites: watchDataSites, arbitrages: watchDataArbitrages, sportradarid: watchSportradarid }} setLeftBar={setLeftBar} setWatchSportradarid={setWatchSportradarid} watchFilters={watchFilters} setWatchFilters={setWatchFilters} fetchSportradaridData={fetchSportradaridData} />}
                                {leftBar == 'stats' && <Stats statsGames={statsGames} setLeftBar={setLeftBar} statsArbitrages={statsArbitrages} />}
                                {leftBar == 'alert' && <Alert alertSettings={alertSettings} setAlertSettings={setAlertSettings} />}
                            </div>
                        </div>
                        <div className='col p-3' style={{ height: 'calc(100vh - 147px)', background: '#161616', overflowY: 'auto' }}>
                            {leftBar !== 'top_arbitrages' && <ArbitragesList token={token} arbitrages={arbitrages} alertSettings={alertSettings} setWatchSportradarid={setWatchSportradarid} setLeftBar={setLeftBar} />}
                            {leftBar == 'top_arbitrages' && <TopArbitragesList topArbitrages={topArbitrages} setWatchSportradarid={setWatchSportradarid} setLeftBar={setLeftBar} />}
                        </div>

                    </div>



                </div>

            }
        </Layout>
    )
}

export default LiveArbitrage
